import { render, staticRenderFns } from "./Archivos.vue?vue&type=template&id=a50421c2&scoped=true&"
import script from "./Archivos.vue?vue&type=script&lang=js&"
export * from "./Archivos.vue?vue&type=script&lang=js&"
import style0 from "./Archivos.vue?vue&type=style&index=0&id=a50421c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50421c2",
  null
  
)

export default component.exports